import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

const ExternalRedirect = (props) => {
    const { from, to, host, exact = true } = props;

    return (
        <Route
            exact={exact}
            path={from}
            component={() => {
                let redirectTo = to || (window.location.pathname + window.location.search);
                if (host) {
                    redirectTo = host + _.trimStart(redirectTo, '/');
                }
                window.location.replace(redirectTo);
                return null;
            }}
        />
    );
};

ExternalRedirect.propTypes = {
    from: PropTypes.string.isRequired,
    to: PropTypes.string,
    host: PropTypes.string,
    exact: PropTypes.bool,
};

export default ExternalRedirect;
